import { useMemo } from 'react';

import { useCreateUserNav } from './useCreateUserNav';
import { useNavOptions } from './useNavOptions';

export const useNav = () => {
	const createUserNav = useCreateUserNav();
	const { admin, superAdmin } = useNavOptions();

	return useMemo(() => {
		return {
			nav: {
				admin: createUserNav(admin),
				superAdmin: createUserNav(superAdmin),
			},
		};
	}, [admin, createUserNav, superAdmin]);
};
